(() => {
  if (customElements.get('lb-media-gallery')) return;
  customElements.define('lb-media-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.dialog = this.querySelector('[data-lb-dialog]');
      if (!this.dialog) return;
      if (this.hasAttribute('data-product-gallery')) this.setupProductGallery(signal);
      this.image = this.querySelector('[data-lb-image]');
      this.error = this.querySelector('[data-lb-error]');
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-lb-open]');
        if (trigger && this.contains(trigger)) {
          const data = document.getElementById(trigger.dataset.lbOpen);
          if (!data) return;
          try { this.images = JSON.parse(data.textContent); } catch (_) { return; }
          if (!this.images.length) return;
          event.preventDefault();
          this.trigger = trigger;
          this.index = Math.max(0, Math.min(this.images.length - 1, Number.parseInt(trigger.dataset.lbIndex || '0', 10) || 0));
          this.previousOverflow = document.body.style.overflow;
          this.dialog.showModal();
          document.body.style.overflow = 'hidden';
          this.show();
        }
      }, {signal});
      this.dialog.addEventListener('click', event => {
        if (event.target.closest('[data-lb-close]') || event.target === this.dialog) this.dialog.close();
        else if (event.target.closest('[data-lb-next]')) this.move(1);
        else if (event.target.closest('[data-lb-prev]')) this.move(-1);
      }, {signal});
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, {signal});
      this.dialog.addEventListener('close', () => this.restore(), {signal});
      this.image.addEventListener('load', () => { this.error.hidden = true; }, {signal});
      this.image.addEventListener('error', () => { this.error.hidden = false; }, {signal});
      this.image.addEventListener('pointerdown', event => {
        this.swipe = event.pointerType === 'touch' && event.isPrimary ? {x:event.clientX,y:event.clientY} : null;
      }, {signal});
      this.image.addEventListener('pointerup', event => {
        if (this.swipe && Math.abs(event.clientX-this.swipe.x)>60 && Math.abs(event.clientY-this.swipe.y)<50) this.move(event.clientX<this.swipe.x ? 1 : -1);
        this.swipe = null;
      }, {signal});
      this.image.addEventListener('pointercancel', () => { this.swipe = null; }, {signal});
      window.addEventListener('resize', () => { if (this.dialog.open) this.size(); }, {signal});
    }
    setupProductGallery(signal) {
      const viewport = this.querySelector('[data-product-viewport]');
      if (!viewport) return;
      const slides = [...viewport.querySelectorAll('[data-product-slide]')];
      const thumbnails = [...this.querySelectorAll('[data-product-thumbnail]')];
      const counter = this.querySelector('[data-product-counter]');
      const controls = this.querySelector('[data-product-controls]');
      const reduce = matchMedia('(prefers-reduced-motion:reduce)');
      let index = 0, frame = 0;
      const hydrate = i => {
        const slide = slides[i], template = slide?.querySelector('template[data-product-image]');
        if (template) { template.replaceWith(template.content.cloneNode(true)); }
      };
      const sync = () => {
        if (!slides.length) return;
        index = Math.max(0, Math.min(slides.length - 1, Math.round(viewport.scrollLeft / Math.max(1, viewport.clientWidth))));
        [index - 1,index,index + 1].forEach(hydrate);
        thumbnails.forEach((thumb,i) => { if(i === index) thumb.setAttribute('aria-current','true'); else thumb.removeAttribute('aria-current'); });
        slides.forEach((slide,i) => { slide.querySelector('[data-lb-open]').tabIndex = i === index ? 0 : -1; });
        if (counter) counter.textContent = `${index + 1} / ${slides.length}`;
        const thumb=thumbnails[index],strip=thumb?.parentElement;
        if(thumb&&strip){const x=thumb.getBoundingClientRect().left-strip.getBoundingClientRect().left+strip.scrollLeft-(strip.clientWidth-thumb.clientWidth)/2;strip.scrollTo({left:Math.max(0,x),behavior:'instant'});}
      };
      const move = (next,instant = false) => {
        if (!slides.length) return;
        next = (next + slides.length) % slides.length;
        [next - 1,next,next + 1].forEach(hydrate);
        viewport.scrollTo({left:next * viewport.clientWidth,behavior:instant || reduce.matches || Math.abs(next-index)>1 ? 'instant' : 'smooth'});
      };
      if (controls) controls.hidden = false;
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-product-thumbnail]');
        if (thumb) { event.preventDefault(); move(Number(thumb.dataset.productThumbnail)); }
        else if (event.target.closest('[data-product-prev]')) move(index - 1);
        else if (event.target.closest('[data-product-next]')) move(index + 1);
      },{signal});
      this.addEventListener('keydown', event => {
        if (event.target.closest('dialog')) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {event.preventDefault();move(index + (event.key === 'ArrowRight' ? 1 : -1));}
        else if (event.key === 'Home' || event.key === 'End') {event.preventDefault();move(event.key === 'Home' ? 0 : slides.length - 1);}
      },{signal});
      viewport.addEventListener('scroll', () => {cancelAnimationFrame(frame);frame=requestAnimationFrame(sync);},{signal,passive:true});
      // Native overflow handles horizontal touch gestures without cancelling vertical page scroll.
      window.addEventListener('resize',()=>move(index,true),{signal});
      signal.addEventListener('abort',()=>cancelAnimationFrame(frame),{once:true});
      sync();
    }
    size() {
      const photo = this.images[this.index];
      this.image.sizes = `${Math.max(1,Math.min(innerWidth-32,(innerHeight-150)*photo.width/photo.height))}px`;
    }
    show() {
      const photo = this.images[this.index];
      this.error.hidden = true;
      this.image.alt = photo.alt || '';
      this.image.width = photo.width; this.image.height = photo.height;
      this.size();
      this.image.srcset = photo.srcset;
      this.image.src = photo.src;
      this.querySelector('[data-lb-caption]').textContent = photo.alt || '';
      this.querySelector('[data-lb-counter]').textContent = `${this.index+1} / ${this.images.length}`;
      this.querySelector('[data-lb-prev]').hidden = this.images.length < 2;
      this.querySelector('[data-lb-next]').hidden = this.images.length < 2;
    }
    move(delta) { this.index = (this.index+delta+this.images.length)%this.images.length; this.show(); }
    restore() {
      document.body.style.overflow = this.previousOverflow || '';
      this.image.removeAttribute('src'); this.image.removeAttribute('srcset');
      const visibleTrigger = this.trigger?.isConnected && this.trigger.getClientRects().length;
      const returnTo = visibleTrigger ? this.trigger : this.querySelector('.lb-campaign__stage');
      returnTo?.focus({preventScroll:true});
    }
    disconnectedCallback() {
      if (this.dialog?.open) { this.dialog.close(); this.restore(); }
      this.abort?.abort(); this.abort = null;
    }
  });
})();
